import BaseModel from "./BaseModel";

export default class Form extends BaseModel {
  private _id: number = -1;
  private _disable_emailing: boolean = false;
  private _method: string = "POST";
  private _redirect_page: string = "/";
  private _title: string = "";

  get id (): number {
    return this._id;
  }

  set id (value: number) {
    this._id = value;
  }

  get disable_emailing (): boolean {
    return this._disable_emailing;
  }

  set disable_emailing (value: boolean) {
    this._disable_emailing = value;
  }

  get method (): string {
    return this._method;
  }

  set method (value: string) {
    this._method = value;
  }

  get redirect_page (): string {
    return this._redirect_page;
  }

  set redirect_page (value: string) {
    this._redirect_page = value;
  }

  get title (): string {
    return this._title;
  }

  set title (value: string) {
    this._title = value;
  }
}
